<template>
  <div
      class="border-r border-b border-l border-gray-400 lg:border-l-0 lg:border-t lg:border-gray-400
        bg-white rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between
        leading-normal h-128 w-8/12 self-center mt-8 mb-8 m-auto l-8 shadow-xl"
    >
    <template v-for="fact in facts">
        <p class="mb-2" :key="fact.id">
          <span v-if="fact.checked">✔️</span>
          <span v-else>❌</span>
          <span class="text-gray-700 text-xs font-bold" v-if="fact.checked">{{ fact.item }}</span>
          <span class="text-red-700 text-xs font-bold" v-else>{{ fact.item }}</span>
        </p>
    </template>
  </div>
</template>
<script>
export default {
  name: 'Facts',
  props: {
    facts: {
      type: Array,
      required: true
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/profiles/single/Facts.vue